import React from 'react';
import { useClingSpriteSheet } from '../../hooks/useClingSpriteSheet';
import { CLING_SHEET, clingDisplaySize, clingFramePosition } from '../../lib/melody/clingSprite';

interface ClingSpriteProps {
  /** Índice de frame en el spritesheet (0–52). */
  frameIndex: number;
  singing?: boolean;
  className?: string;
  filter?: string;
}

export const ClingSprite: React.FC<ClingSpriteProps> = ({
  frameIndex,
  singing = false,
  className = '',
  filter,
}) => {
  const { sheetSrc, ready } = useClingSpriteSheet();
  const { width, height } = clingDisplaySize();
  const pos = clingFramePosition(frameIndex, sheetSrc);

  return (
    <div
      className={`cling-canta-cling-sprite ${singing ? 'cling-canta-cling-sprite--sing' : ''} ${className} ${
        ready ? 'cling-canta-cling-sprite--ready' : ''
      } ${CLING_SHEET.flipX ? 'cling-canta-cling-sprite--flip' : ''}`}
      style={{
        width,
        height,
        backgroundImage: `url(${pos.sheetSrc})`,
        backgroundSize: `${pos.sheetWidth}px ${pos.sheetHeight}px`,
        backgroundPosition: `-${pos.bgX}px -${pos.bgY}px`,
        backgroundRepeat: 'no-repeat',
        filter: filter && filter !== 'none' ? filter : undefined,
      }}
      role="img"
      aria-label="Cling"
    />
  );
};

export default ClingSprite;
